export default __webpack_public_path__ + "static/media/burntodeath3.c57a4905.png";